// src/client/utils/tourTableHelpers.js

/**
 * Shared utility functions for PropertyToursTable and UserToursTable components.
 * Extracted to avoid duplication across property-scoped and user-scoped tour tables.
 */

/**
 * Whether the current user can cancel or reschedule this tour.
 * Backend computes this as: (Admin in same org OR assigned agent) AND status === "scheduled"
 * AND current time in property tz <= tour start time.
 */
export const canCancelTour = (tour) => tour.can_cancel;

/**
 * Whether the current user can add or edit notes/feedback on this tour.
 * Backend computes this as: Admin in same org OR assigned agent.
 * No time-window restriction (notes are editable on completed tours).
 */
export const canEditTourNotes = (tour) => tour.can_edit_notes;

/**
 * Formats long email addresses for table display by splitting at the @ symbol.
 * Returns a React fragment with a line break for emails longer than 20 characters.
 *
 * Note: Returns JSX — import React in consuming files.
 */
export const formatEmailForTable = (email) => {
	if (email.length > 30) {
		const atIndex = email.indexOf("@");
		if (atIndex > 0) {
			return (
				<>
					{email.substring(0, atIndex)}
					<br />
					{email.substring(atIndex)}
				</>
			);
		}
	}
	return email;
};

/**
 * Formats move-in date with a label prefix and space separator for table display.
 * Returns a React fragment with a line break.
 *
 * Note: Returns JSX — import React in consuming files.
 */
export const formatMoveInDate = (moveInDate) => <>Move-in: {moveInDate}</>;
